import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import FileSelectorButton from '@/components/Ui/FileSelectorButton'
import ServiceDropboxSelector from '@/components/Ui/ServiceDropboxSelector'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Jsonb from '@/utils/Jsonb'
import Validator from '@/utils/Validator'

export default {
  name: 'ServiceContentsSettingInputBasicSetting',
  components: {
    FileSelectorButton,
    ServiceDropboxSelector
  },
  data () {
    return {
      inited: false,

      input: {
        serviceTypeCd: '',
        contentsName: null,
        deviceTypeUuid: '',
        splashImageFile: null,
        bgMusicFile: null,
        bgImage: {
          sourceType: '',
          selectedFiles: [null, null, null],
          dropBoxFile: {
            serviceDropboxUuid: '',
            fileType: ''
          }
        },
        bgPanelFlg: 0,
        bgPanelColor: null,
        bgPanelTransparency: null,
        UseStartImage1: null,
        UseStartImage2: null,
        UseStartImage3: null,
        screenOrientation: 0,
        screenBottomMargin: 0,
        screenOffTimeOut: 180,
      }
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      categoryName: state => state.serviceContentsSetting.categoryName,
      
      // model
      serviceTypeModel: state => state.serviceContentsSettingForm.serviceTypeModel,
      deviceModel: state => state.serviceContentsSettingForm.deviceModel,

      // form
      serviceId: state => state.serviceContentsSettingForm.serviceId,
      serviceContentsId: state => state.serviceContentsSettingForm.targetId,
      values: state => state.serviceContentsSettingForm.values,

      // result
      resultServiceContentsId: state => state.serviceContentsSettingForm.serviceContentsId,
    }),
    ...mapGetters({
      permittedView: 'permission/permittedView',
      isRegister: 'serviceContentsSettingForm/isRegister',
      isModify: 'serviceContentsSettingForm/isModify',
    }),

    // list
    serviceTypeList () {
      let list = []
      this.serviceTypeModel.forEach(item => list.push({
        value: item.serviceTypeCd,
        label: item.serviceTypeName
      }))
      return list
    },
    deviceList () {
      let list = []
      this.deviceModel.forEach(item => list.push({
        value: item.deviceTypeUuid,
        label: item.modelNumber
      }))
      return list
    },
    bgSourceTypeList () {
      return Constants.ServiceContents.BgSourceType
    },
    bgPanelList () {
      return Constants.ServiceContents.BgPanel.sort(Utility.sortByKey('index', true))
    },
    screenOrientationList () {
      return Constants.ServiceContents.ScreenOrientation
    },
    screenOffTimeList() {
      return Constants.ServiceContents.ScreenOffTime
    },

    // validate
    formIsValid () {
      const v1 = this.validate('serviceTypeCd') &&
        this.validate('contentsName') &&
        this.validate('deviceTypeUuid') &&
        this.validate('splashImageFile') &&
        this.validate('bgMusicFile') &&
        this.validate('bgImage.sourceType') &&
        this.validate('bgPanelFlg') &&
        this.validate('UseStartImage1') &&
        this.validate('UseStartImage2') &&
        this.validate('UseStartImage3') &&
        this.validate('screenOrientation') &&
        this.validate('screenBottomMargin')
      if (!v1) return false

      // 背景画像のタイプ別にバリデート
      let v2 = false
      if (this.input.bgImage.sourceType === 0) {
        v2 = this.validate('bgImage.selectedFiles.0')
      } else {
        v2 = this.validate('bgImage.dropBoxFile.fileType') &&
          this.validate('bgImage.dropBoxFile.serviceDropboxUuid')
      }
      if (!v2) return false

      return true
    },

    // jsonb
    getJsonb () {
      let jsonb = {
        serviceTypeCd: this.input.serviceTypeCd,
        contentsName: this.input.contentsName,
        deviceTypeUuid: this.input.deviceTypeUuid,
        splashImageFile: this.input.splashImageFile,
        bgMusicFile: this.input.bgMusicFile,
        bgImage: {
          sourceType: this.input.bgImage.sourceType,
        },
        bgPanelFlg: this.input.bgPanelFlg,
        UseStartImage1: this.input.UseStartImage1,
        UseStartImage2: this.input.UseStartImage2,
        UseStartImage3: this.input.UseStartImage3,
        screenOrientation: this.input.screenOrientation,
        screenBottomMargin: this.input.screenBottomMargin,
      }
      
      // ファイル選択
      if (jsonb.bgImage.sourceType === 0) {
        this.$set(jsonb.bgImage, 'selectedFiles', this.input.bgImage.selectedFiles
          .filter(item => item !== null))
      // Dropbox設定
      } else {
        this.$set(jsonb.bgImage, 'dropBoxFile', this.input.bgImage.dropBoxFile)
      }

      // 背景パネル
      if (jsonb.bgPanelFlg === 1 &&
        Validator.validText(this.input.bgPanelColor)) {
        jsonb.bgPanelColor = this.input.bgPanelColor
      }
      if (jsonb.bgPanelFlg === 1 &&
        Validator.validateNumber(this.input.bgPanelTransparency)) {
        jsonb.bgPanelTransparency = this.input.bgPanelTransparency
      }

      // スクリーンオフ設定
      if (this.input.screenOffTimeOut !== '') {
        jsonb.screenOffTimeOut = this.input.screenOffTimeOut
      }

      return jsonb
    },
  },
  watch: {
    // 入力値が変更されたらモジュール全体のバリデート結果をstoreに保持
    input: {
      handler: function (to) {
        this.setValidate({
          key: 'basicSetting',
          value: this.formIsValid
        })
      },
      deep: true
    }
  },
  methods: {
    ...mapActions({

    }),
    ...mapMutations({
      setValues: 'serviceContentsSettingForm/setValues',
      setInputValue: 'serviceContentsSettingForm/setInputValue',
      setValidate: 'serviceContentsSettingForm/setValidate'
    }),

    init () {
      if (this.values.contentsBasicSetting) {
        let data = $.extend(true, this.input, this.values.contentsBasicSetting)
        this.$set(this, 'input', data)
      }
        
      this.setValidate({
        key: 'basicSetting',
        value: this.formIsValid
      })

      this.inited = true
    },

    /**
     * ファイル
     */
    getInputNode (name) {
      let nodes = name.split('.')
      let origin = this.input
      let key
      nodes.forEach((item, index) => {
        if (index < nodes.length - 1) {
          origin = origin[item]
        } else {
          key = item
        }
      })
      return {
        parent: origin,
        key: key
      }
    },
    /**
     * ファイルの変更
     */
    changeFileFromSelector (props) {
      let data = this.getInputNode(props.name)
      this.$set(data.parent, data.key, Jsonb.formatFile(props.data))
      console.log('changeFileFromSelector', data.parent[data.key])
    },
    /**
     * ファイルの削除
     */
    deleteFileFromSelector (props) {
      let data = this.getInputNode(props.name)
      this.$set(data.parent, data.key, null)
      console.log('deleteFileFromSelector', null)
    },

    /**
     * Dropbox設定の変更
     */
    changeDropboxValue (props) {
      console.log('changeDropboxValue', props)
      this.$set(this.input.bgImage, 'dropBoxFile', props.value)
    },

    validate (key) {
      let data = this.getInputNode(key)
      let value = data.parent[data.key]
      switch (key) {
        case 'serviceTypeCd':
        case 'bgImage.dropBoxFile.fileType':
        case 'bgImage.dropBoxFile.serviceDropboxUuid':
          return Validator.validSelect(value)
        case 'contentsName':
        case 'deviceTypeUuid':
          return Validator.validText(value)
        case 'splashImageFile':
        case 'bgMusicFile':
          return Validator.validFile(value)
        case 'bgImage.sourceType':
        case 'bgPanelFlg':
          return Validator.validRadio(value)
        case 'UseStartImage1':
        case 'UseStartImage2':
        case 'UseStartImage3':
        case 'bgImage.selectedFiles.0':
        case 'bgImage.selectedFiles.1':
        case 'bgImage.selectedFiles.2':
          return Validator.validFile(value)
        case 'screenOrientation':
          return Validator.validRadio(value)
        case 'screenBottomMargin':
          return Validator.validateNumber(value, {min: 0})
      }
    },
  }
}
